import type { TrainingLmsAction, TrainingLmsRules } from "@simbelapp/order-sdk";
import { toValue, type MaybeRefOrGetter } from "vue";

export const useTrainingLmsRules = (
  isExternalLms: MaybeRefOrGetter<boolean | undefined>,
  lmsRules: MaybeRefOrGetter<TrainingLmsRules | null | undefined>,
) => {
  function isLmsActionDisabled(ruleName: TrainingLmsAction): boolean {
    if (!toValue(isExternalLms)) return false;
    const rules = toValue(lmsRules);
    if (!rules) return true;
    return !rules[ruleName];
  }

  return { isLmsActionDisabled };
};
